module.exports = __webpack_public_path__ + "media/video408.e76de78d.mp4";